module.exports = __webpack_public_path__ + "img/dlt_kind_3.b04260ef.svg";